import { RawTicket } from '@/pages/ReceptionistDashboard/FormResponses/types';
import { Card, List, Avatar, Typography, Divider } from 'antd';
import { QuestionCircleOutlined, CheckCircleOutlined, TagsOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export const CallTicketsCard = ({
	tickets,
	style,
}: {
	tickets: RawTicket[];
	style?: React.CSSProperties;
}) => {
	if (!tickets || tickets.length === 0) {
		return (
			<Card style={style}>
				<Text>No tickets were generated for this call.</Text>
			</Card>
		);
	}

	return (
		<Card className="bg-white rounded-xl" style={style} bodyStyle={{ padding: '20px' }}>
			{tickets.map((ticket, ticketIndex) => (
				<div key={ticket.ticketId}>
					<div className="flex items-center mb-4">
						<TagsOutlined className="text-xl text-gray-500 mr-3" />
						<Title level={5} className="!mb-0">
							{ticket.ticketTitle || 'Ticket Details'}
						</Title>
					</div>

					<List
						dataSource={ticket.responses}
						renderItem={(response, index) => (
							<>
								<List.Item
									key={`${index}-q`}
									className="border-none py-3 px-0 w-full flex justify-start"
								>
									<div className="flex items-start gap-2 max-w-[75%]">
										<Avatar
											icon={<QuestionCircleOutlined />}
											className="bg-purple-500 text-white shadow-md h-8 w-8 mt-1"
										/>
										<div className="p-3 px-4 rounded-xl shadow-sm flex flex-col gap-1 bg-purple-50">
											<Text className="text-[13px] font-semibold text-purple-500">Question</Text>
											<Text className="text-sm text-slate-700">{response.question}</Text>
										</div>
									</div>
								</List.Item>

								<List.Item
									key={`${index}-a`}
									className="border-none py-3 px-0 w-full flex justify-end"
									style={{ display: 'flex', justifyContent: 'flex-end' }}
								>
									<div className="flex items-start gap-2 max-w-[75%]">
										<div className="p-3 px-4 rounded-xl shadow-sm flex flex-col gap-1 bg-blue-50">
											<Text className="text-[13px] font-semibold text-blue-500">Answer</Text>
											<Text className="text-sm text-slate-700">{response.answer}</Text>
										</div>
										<Avatar
											icon={<CheckCircleOutlined />}
											className="bg-blue-500 text-white shadow-md h-8 w-8 mt-1"
										/>
									</div>
								</List.Item>
							</>
						)}
					/>
					{ticketIndex < tickets.length - 1 && <Divider />}
				</div>
			))}
		</Card>
	);
};
